$(function() {

    $document = $(document);

    $document.foundation();


    //certified sites view switch
    $('#mapView').hide();
    $document.on('click', '#viewGrid', function(e) {
        $(this).addClass('is-active');
        $('#viewMap').removeClass('is-active');
        $('#gridView').show();
        $('#sort').show();
        $('#mapView').hide();

    });
    $document.on('click', '#viewMap', function(e) {
        $(this).addClass('is-active');
        $('#viewGrid').removeClass('is-active');
        $('#mapView').show();
        $('#gridView').hide();
        $('#sort').hide();

    });

    $document.on('change', '.category_filter', function(e) {
     var selectedOptionText = $(this).find('option:selected').text();
    });


    $('#filters').click(function(){
        $('.filterAccordionContainer').toggle();
    });
    $('#clearFilters').click(function(){
        //$('select').val('');
        location.reload(true);
    });


    

    // slick carousel

        $('.slick-hero').slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
            fade: true,
            speed: 500,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            arrows: false
        });

        $('.advantage-slider').slick({
            autoplay: true,
            infinite: true,
            fade: true,
            speed: 500,
            autoplaySpeed: 7000,
            dots: true,
            arrows: false,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
        });

        $('.slick-region').slick({
            autoplay: true,
            infinite: true,
            autoplaySpeed: 7000,
            dots: true,
            fade: true,
            speed: 500,
            arrows: false,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
        });

        // $('.subpage-slider-text').slick({
        //     //autoplay: true,
        //     infinite: true,
        //     //autoplaySpeed: 3000,
        //     dots: true,
        //     fade: true,
        //     speed: 500,
        //     arrows: false,
        //     draggable: false,
        //     touchMove: false,
        //     pauseOnFocus: false,
        //     pauseOnHover: false,
        //     asNavFor: '#subpageSummaryBg',
        // });

        // $('#subpageSummaryBg').slick({
        //     autoplay: true,
        //     infinite: true,
        //     autoplaySpeed: 7000,
        //     arrows: false,
        //     fade: true,
        //     speed: 500,
        //     draggable: false,
        //     touchMove: false,
        //     pauseOnFocus: false,
        //     pauseOnHover: false,
        //     asNavFor: '.subpage-slider-text'
        // })

        $('.company-slider').slick({
            autoplay: true,
            infinite: true,
            autoplaySpeed: 3500,
            slidesToShow: 3,
            speed: 500,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
            responsive: [
                {
                    breakpoint: 1079,
                    settings: {
                        slidesToShow: 2,
                        draggable: false,
                        touchMove: false,
                    }
                },
                {
                    breakpoint: 639,
                    settings: {
                        slidesToShow: 1,
                        draggable: false,
                        touchMove: false,
                    }
                }
            ]
        });

        $('.know-slider').slick({
            autoplay: true,
            infinite: true,
            autoplaySpeed: 7500,
            dots: true,
            arrows: false,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
        });

        $('.facts-slider').slick({
            autoplay: true,
            infinite: true,
            autoplaySpeed: 7500,
            dots: true,
            arrows: false,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
        });

        $('.story-slider').slick({
            prevArrow: $('.prev-arrow'),
            nextArrow: $('.next-arrow'),
            draggable: false,
            touchMove: false,
            swipe: false,
            infinite: false,
            adaptiveHeight: true
        });

        $('.why-slider').slick({
            autoplay: true,
            infinite: true,
            autoplaySpeed: 7500,
            dots: true,
            arrows: false,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
        });

        $('.sub-slider').slick({
            autoplay: true,
            infinite: true,
            autoplaySpeed: 7500,
            dots: true,
            arrows: false,
            draggable: false,
            touchMove: false,
            pauseOnFocus: false,
            pauseOnHover: false,
        });


    $document.on('click', '.prev-arrow', function(e) {
        $('.story-slider').removeClass("hiddenContent");
        $('.story-shader').addClass("hide");
        $('.readCell').addClass("hide");
        $document.scrollTop($("#moreStories").offset().top);
    });

    $document.on('click', '.next-arrow', function(e) {
        $('.story-slider').removeClass("hiddenContent");
        $('.story-shader').addClass("hide");
        $('.readCell').addClass("hide");
        $document.scrollTop($("#moreStories").offset().top);
    });

    $document.on('click', '.readIcon', function(e) {
        $('.story-slider').removeClass("hiddenContent");
        $('.story-shader').addClass("hide");
        $('.readCell').addClass("hide");      
    });

    setInterval(function() {
        var y = $document.scrollTop();
        if (y > 500) {
            $('.up-arrow').fadeIn();
        } else {
            $('.up-arrow').fadeOut();
        }
    }, 750);

    $document.on('click', '.up-arrow', function(e) {
        $document.scrollTop(0);
    });
    

    // content gate
/*
    if ($('#overlayGate').length) {
        var elem = new Foundation.Reveal($('#overlayGate'));
        $('#overlayGate').foundation('open');
    }

    $document.on('closed.zf.reveal', '#overlayGate', function() {
        $('#overlayCookies').hide();
    });

    $document.on('click', '#overlayGateButton', function(e) {
        e.preventDefault();
    });
*/
    // cookies gate
/*
    $document.on('click', '#cookiesGateButton', function(e) {
        e.preventDefault();
        $('#overlayCookies').fadeOut();
    });
*/
    // lightbox overlay trigger
/*
    $document.on('click', 'a.lightbox', function(e) {
        if (window.innerWidth > 1024) {
            e.preventDefault();
            var url = $(this).attr('href');
            var filename = url.split('.').pop().toLowerCase();
            var imgclass = 'img-fluid';
            if (filename === 'svg') {
                imgclass += ' img-vector';
            }
            $('#overlayPreviewContent').css('background-image','url("'+url+'")');
            $('#overlayPreview').foundation('open');
        }
    });
*/

    // video lightbox trigger

    $document.on('click', 'a.videolightbox', function(e) {
        e.preventDefault();
        var id = $(this).attr('data-id');
        $('#overlayVideo_'+id).foundation('open');
    });

    $document.on('closed.zf.reveal', '.videoOverlay', function() {
        var videoId = $(this).attr('data-video-id');
        var video = document.getElementById('overlayVideoPlayer_'+videoId);
        video.pause();
//        video.currentTime = 0;
    });

    // share overlay trigger

    $document.on('click', '#pageShare .popup a', function(e) {
        if (window.innerWidth > 1024) {
            e.preventDefault();
            var url = $(this).attr('href');
            var newWindow = window.open(url, 'Share', 'scrollbars=yes, width=1024, height=660');
            if (window.focus) {
                newWindow.focus();
            }
        }
    });

    // scroll to anchor on click

    var href = location.protocol + '//' + location.host + location.pathname;

    $document.on('click', 'a[href^="#"],a[href^="'+href+'#"]', function(e) {
        if ($(this).hasClass('accordion-title') || $(this).parent().hasClass('tabs-title') || $(this).hasClass('content-tab-title')) {
            return;
        }
        var idsplit = $(this).attr('href').split('#')[1];
        if (idsplit.length > 0) {
            var $id = $('#'+idsplit);
            if ($id.length === 0) {
                return;
            }
            e.preventDefault();
            // $('#offCanvas').foundation('close');
            var headerHeight = $('#header').height();
            var pos = $id.offset().top - headerHeight - 88;
            $('body, html').animate({scrollTop: pos}, 600);
        }
    });

    // scroll to anchor on load

    if (location.hash) {
        var $id = $(location.hash);
        if ($id.length) {
            var headerHeight = $('#header').height();
            var pos = $id.offset().top - headerHeight - 88;
            $('body, html').animate({scrollTop: pos}, 600);
        }
    }

/*
    // animate numbers

    function animateNumber($selector) {

    	var end_num = parseFloat($selector.attr('data-value'), 10);
    	var decimal = false;

    	if (isNaN(end_num)) {
            end_num = 0;
        }
    	if (end_num % 1 !== 0) {
            decimal = true;
        }

    	$({numberValue: 0}).animate({numberValue: end_num}, {
    		duration: 1000,
    		easing: 'linear',
    		progress: function() {
    			if (decimal) {
                    var num = Math.ceil(this.numberValue*100)/100;
    			} else {
    				var num = Math.ceil(this.numberValue);
    			}
                $selector.text(new Intl.NumberFormat('en-CA', {maximumFractionDigits: 1}).format(num));
    		},
    		complete: function() {
    			var n = parseFloat($selector.text(), 10);
    			if (n !== end_num) {
    				n = end_num;
                    $selector.text(new Intl.NumberFormat('en-CA', {maximumFractionDigits: 1}).format(Math.ceil(end_num)));
    			}
                $selector.addClass('animateNumberDone');
    		}
    	});

    }

    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.attributeName === "class") {
                var $elem = $(mutation.target);
                var attributeValue = $elem.prop(mutation.attributeName);
                if (!$elem.hasClass('animateNumberDone') && $elem.hasClass('aos-animate')) {
                    animateNumber($elem);
                }
            }
        });
    });

    $('.animateNumber').each(function() {
        observer.observe(this, {
            attributes: true
        });
    });

    AOS.init();
*/


    // for landowners section tab indicators

    $('.dots li').on('click', function() {
        var index = $(this).index();
        
        $('.dots li').removeClass('active');
        $(this).addClass('active');
        
        $('.tabs-title').removeClass('is-active');
        $('.tabs-title').eq(index).addClass('is-active');
        
        $('.tabs-panel').removeClass('is-active');
        $('.tabs-panel').eq(index).addClass('is-active');
    });

    $('.tabs-title').on('click', function() {
        var index = $(this).index();
        
        $('.dots li').removeClass('active');
        $('.dots li').eq(index).addClass('active');
    });
});
